import React, { FC } from "react";
import type { PaymentOrchestrationLastMileConnectivityProps } from "@/types";
import { Image } from "../image";
import { Tags } from "../tags";
import { TextCols } from "../text-cols";

export const PaymentOrchestrationLastMileConnectivity: FC<PaymentOrchestrationLastMileConnectivityProps> = ({
  content,
  tags,
  cover,
}) => {
  return (
    <section className="paymentOrchestrationLastMileConnectivity">
      <div className="paymentOrchestrationLastMileConnectivity--inner">
        <div className="wrapper">
          <TextCols content={content} maxTitleWidth={770} />
        </div>
        <Tags
          tags={tags}
          className="paymentOrchestrationLastMileConnectivity--tags"
        />
        <div className="wrapper wrapper_lg">
          {cover.file?.url && (
            <Image
              className="paymentOrchestrationLastMileConnectivity--cover"
              src={cover as any}
              alt={cover.title}
              animateInView
            />
          )}
        </div>
      </div>
    </section>
  );
};
